<template>
  <div class="app-version-manager">
    <div class="page-title">移动端版本管理</div>

    <div class="search-bar">
      <el-input v-model="query.search" placeholder="请输入版本号/文件名/标题" clearable class="search-input" @keyup.enter.native="loadList" />
      <el-select v-model="query.platform" placeholder="平台" clearable class="search-select">
        <el-option label="Android" value="android" />
        <el-option label="iOS" value="ios" />
        <el-option label="全部" value="all" />
      </el-select>
      <el-select v-model="query.status" placeholder="状态" clearable class="search-select">
        <el-option label="草稿" :value="0" />
        <el-option label="已发布" :value="1" />
        <el-option label="已下架" :value="2" />
      </el-select>
      <el-button type="primary" @click="loadList">查询</el-button>
      <el-button type="primary" @click="openDialog()">新增</el-button>
      <el-button v-if="$route.path === '/appVersionManager'" @click="$router.push('/mainAdmin')">返回总后台</el-button>
    </div>

    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="versionName" label="版本名称" width="120" />
      <el-table-column prop="versionCode" label="版本号" width="90" />
      <el-table-column label="平台" width="90">
        <template slot-scope="scope">{{ platformName(scope.row.platform) }}</template>
      </el-table-column>
      <el-table-column label="包类型" width="90">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.packageType === 'wgt' ? 'success' : 'primary'">{{ scope.row.packageType }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="fileName" label="文件名" min-width="180" show-overflow-tooltip />
      <el-table-column label="强制更新" width="90">
        <template slot-scope="scope">{{ scope.row.forceUpdate === 1 ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag size="mini" :type="statusType(scope.row.status)">{{ statusName(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="publishTime" label="发布时间" width="160" />
      <el-table-column label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openDialog(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status !== 1" type="text" size="small" @click="publishRow(scope.row)">发布</el-button>
          <el-button v-if="scope.row.status === 1" type="text" size="small" @click="unpublishRow(scope.row)">下架</el-button>
          <el-button type="text" size="small" @click="copyUrl(scope.row)">复制地址</el-button>
          <el-button type="text" size="small" class="danger-text" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, prev, pager, next, sizes"
        :current-page="query.curPage"
        :page-size="query.limit"
        :total="total"
        @current-change="pageChange"
        @size-change="sizeChange" />
    </div>

    <el-dialog :title="form.id ? '编辑版本' : '新增版本'" :visible.sync="dialogVisible" width="680px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="AppId" prop="appId">
          <el-input v-model="form.appId" placeholder="例如 __UNI__04D8B16" />
        </el-form-item>
        <el-form-item label="平台" prop="platform">
          <el-select v-model="form.platform" placeholder="请选择平台" style="width: 100%">
            <el-option label="Android" value="android" />
            <el-option label="iOS" value="ios" />
            <el-option label="全部" value="all" />
          </el-select>
        </el-form-item>
        <el-form-item label="版本名称" prop="versionName">
          <el-input v-model="form.versionName" placeholder="例如 1.1.1" />
        </el-form-item>
        <el-form-item label="版本号" prop="versionCode">
          <el-input-number v-model="form.versionCode" :min="1" style="width: 100%" />
        </el-form-item>
        <el-form-item label="包类型" prop="packageType">
          <el-radio-group v-model="form.packageType">
            <el-radio label="wgt">wgt 热更新包</el-radio>
            <el-radio label="apk">apk 整包</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传包" prop="packageUrl">
          <el-upload
            action="/v1/appVersion/uploadFile"
            :headers="uploadHeaders"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-error="uploadError">
            <el-button type="primary" size="small">上传 .apk / .wgt</el-button>
            <span class="upload-tip" v-if="form.fileName">{{ form.fileName }}</span>
          </el-upload>
          <el-input v-model="form.packageUrl" placeholder="上传后自动生成包地址，也可手动填写" class="package-url-input" />
        </el-form-item>
        <el-form-item label="更新标题">
          <el-input v-model="form.updateTitle" placeholder="例如 发现新版本" />
        </el-form-item>
        <el-form-item label="更新说明">
          <el-input v-model="form.updateContent" type="textarea" :rows="4" placeholder="请输入更新说明" />
        </el-form-item>
        <el-form-item label="强制更新">
          <el-switch v-model="form.forceUpdateSwitch" active-text="是" inactive-text="否" />
        </el-form-item>
        <el-form-item label="最低版本号">
          <el-input-number v-model="form.minVersionCode" :min="0" style="width: 100%" />
          <div class="form-tip">客户端版本号低于该值时会强制更新；不需要时填 0。</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listAppVersion, saveAppVersion, updateAppVersion, deleteAppVersion, publishAppVersion, unpublishAppVersion } from '@/api/appVersion'

const defaultForm = () => ({
  id: null,
  appId: '__UNI__04D8B16',
  platform: 'android',
  versionName: '',
  versionCode: 101,
  packageType: 'wgt',
  packageUrl: '',
  fileName: '',
  fileSize: '',
  md5: '',
  updateTitle: '发现新版本',
  updateContent: '',
  forceUpdate: 0,
  forceUpdateSwitch: false,
  minVersionCode: 0,
  status: 0
})

export default {
  name: 'AppVersionManager',
  data() {
    return {
      query: {
        search: '',
        platform: '',
        status: '',
        curPage: 1,
        limit: 10
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: defaultForm(),
      rules: {
        appId: [{ required: true, message: '请填写AppId', trigger: 'blur' }],
        platform: [{ required: true, message: '请选择平台', trigger: 'change' }],
        versionName: [{ required: true, message: '请填写版本名称', trigger: 'blur' }],
        versionCode: [{ required: true, message: '请填写版本号', trigger: 'blur' }],
        packageType: [{ required: true, message: '请选择包类型', trigger: 'change' }],
        packageUrl: [{ required: true, message: '请上传版本包', trigger: 'blur' }]
      },
      uploadHeaders: {
        'X-Access-Token': sessionStorage.getItem('token') || localStorage.getItem('token') || ''
      }
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    async loadList() {
      const params = Object.assign({}, this.query)
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) delete params[key]
      })
      const res = await listAppVersion(params)
      const body = res.body || {}
      const data = Array.isArray(body.data) ? body.data : (Array.isArray(body.records) ? body.records : [])
      this.tableData = data
      this.total = Number(body.cum || body.total || data.length || 0)
    },
    pageChange(page) {
      this.query.curPage = page
      this.loadList()
    },
    sizeChange(size) {
      this.query.limit = size
      this.query.curPage = 1
      this.loadList()
    },
    openDialog(row) {
      this.form = row ? Object.assign(defaultForm(), row, { forceUpdateSwitch: row.forceUpdate === 1 }) : defaultForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        const params = Object.assign({}, this.form, {
          forceUpdate: this.form.forceUpdateSwitch ? 1 : 0,
          minVersionCode: this.form.minVersionCode || 0
        })
        if (params.fileSize === '') delete params.fileSize
        delete params.forceUpdateSwitch
        if (params.id) {
          await updateAppVersion(params)
          this.$message.success('修改成功')
        } else {
          delete params.id
          await saveAppVersion(params)
          this.$message.success('新增成功')
        }
        this.dialogVisible = false
        this.query.curPage = 1
        this.loadList()
      })
    },
    beforeUpload(file) {
      const name = file.name.toLowerCase()
      const ok = name.endsWith('.apk') || name.endsWith('.wgt')
      if (!ok) this.$message.error('只允许上传 .apk 或 .wgt 文件')
      return ok
    },
    uploadSuccess(res) {
      if (res.status_code !== 100) {
        this.$message.error(res.error_msg || '上传失败')
        return
      }
      const data = res.data || {}
      this.form.packageUrl = data.packageUrl || ''
      this.form.fileName = data.fileName || ''
      this.form.fileSize = data.fileSize || ''
      this.form.md5 = data.md5 || ''
      if (data.packageType) this.form.packageType = data.packageType
      this.$message.success('上传成功')
    },
    uploadError() {
      this.$message.error('上传失败')
    },
    deleteRow(row) {
      this.$confirm('确认删除该版本吗？', '提示', { type: 'warning' }).then(async () => {
        await deleteAppVersion(row.id)
        this.$message.success('删除成功')
        this.loadList()
      }).catch(() => {})
    },
    publishRow(row) {
      this.$confirm('确认发布该版本吗？发布后移动端会检查到该版本。', '提示', { type: 'warning' }).then(async () => {
        await publishAppVersion(row.id)
        this.$message.success('发布成功')
        this.loadList()
      }).catch(() => {})
    },
    unpublishRow(row) {
      this.$confirm('确认下架该版本吗？', '提示', { type: 'warning' }).then(async () => {
        await unpublishAppVersion(row.id)
        this.$message.success('下架成功')
        this.loadList()
      }).catch(() => {})
    },
    copyUrl(row) {
      const input = document.createElement('input')
      input.value = row.packageUrl || ''
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('已复制')
    },
    platformName(value) {
      return value === 'ios' ? 'iOS' : value === 'all' ? '全部' : 'Android'
    },
    statusName(value) {
      return value === 1 ? '已发布' : value === 2 ? '已下架' : '草稿'
    },
    statusType(value) {
      return value === 1 ? 'success' : value === 2 ? 'info' : 'warning'
    }
  }
}
</script>

<style scoped>
.app-version-manager {
  padding: 18px 24px;
  background: #fff;
  min-height: calc(100vh - 80px);
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 18px;
}
.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.search-input {
  width: 260px;
  margin-right: 10px;
}
.search-select {
  width: 130px;
  margin-right: 10px;
}
.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
.upload-tip {
  margin-left: 12px;
  color: #606266;
}
.package-url-input {
  margin-top: 10px;
}
.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}
.danger-text {
  color: #f56c6c;
}
</style>
